import { render, staticRenderFns } from "./proposta.vue?vue&type=template&id=7c80fdd8&scoped=true"
import script from "./proposta.vue?vue&type=script&lang=js"
export * from "./proposta.vue?vue&type=script&lang=js"
import style0 from "./proposta.vue?vue&type=style&index=0&id=7c80fdd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c80fdd8",
  null
  
)

export default component.exports